let API_BASE_URL;
console.log("process.env.REACT_APP_ENVIROMENT", process.env.REACT_APP_ENVIROMENT)
if (process.env.REACT_APP_ENVIROMENT === "LIVE") {
  API_BASE_URL = process.env.REACT_APP_API_END_POINT_LIVE;
} else {
  API_BASE_URL = process.env.REACT_APP_API_END_POINT_DEV;
}

const fetchWithTimeout = async (url, options, timeout = 10000) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, { ...options, signal: controller.signal });
    clearTimeout(id);
    return response;
  } catch (error) {
    clearTimeout(id);
    throw error;
  }
};

const endpoints = {
  async fetchScorecard(matchId, matchType = "regular") {
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}/scorecard`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          match_id: parseInt(matchId),
          match_type: matchType
        })
      }, 10000);
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch scorecard: ${error.message}`);
    }
  },

  async fetchFinalScoreCard(matchId, matchType = "regular") {
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}/finalScoreCard`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          match_id: parseInt(matchId),
          match_type: matchType
        })
      }, 10000);
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch final scorecard: ${error.message}`);
    }
  },

  async fetchBowlerHistory(matchId, matchType, bowler, team_name = "") {
    try {
      const requestBody = {
        match_id: parseInt(matchId),
        match_type: matchType || "regular",
        bowler_name: bowler.bowler_name.trim(),
        bowler_id: bowler.bowler_id || "",
        team_name: team_name!= "" ? team_name:bowler.team_name
      };

      const response = await fetchWithTimeout(`${API_BASE_URL}/bowlerHistory`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody)
      }, 10000);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch bowler history: ${error.message}`);
    }
  },

  async fetchBatsmanHistory(matchId, matchType, batsman, team_name = "") {
    try {
      const requestBody = {
        match_id: parseInt(matchId),
        match_type: matchType || "regular",
        batsman_name: batsman.batsman_name.trim(),
        batsman_id: batsman.batsman_id || "",
        team_name: team_name!= "" ? team_name:batsman.team_name
      };

      const response = await fetchWithTimeout(`${API_BASE_URL}/batsmanHistory`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody)
      }, 10000);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch batsman history: ${error.message}`);
    }
  },

  async getMatchList(is_my_match = "0", page = "1", perPage = "20") {
    // console.log("Sending API Request with:", { is_my_match, page, perPage });
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}/list-match`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          is_my_match,
          page,
          perPage
        })
      });

      const result = await response.json();
      // console.log("API Response:", result);
      return result;
    } catch (error) {
      console.error("API Error:", error);
      return { success: false, message: "API call failed" };
    }
  },

  async fetchSummaryDataLive(matchId, matchType) {
    try {
      const response = await fetchWithTimeout(`${API_BASE_URL}/match-summary`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          match_id: matchId,
          match_type: matchType
        })
      }, 10000);
      const data = await response.json();
      return data;
    } catch (err) {
      throw err;
    }
  }
};

export default endpoints;